<template>
  <div v-if="loading" class="form-skeleton-loader">
    <!-- Form Header Section -->
    <div class="form-section mb-4">
      <b-row>
        <b-col cols="12">
          <Skeleton width="40%" height="2rem" class="mb-3" />
        </b-col>
      </b-row>
    </div>

    <!-- Form Fields Section 1 -->
    <div class="form-section mb-4">
      <b-row>
        <b-col cols="12">
          <Skeleton width="25%" height="1.2rem" class="mb-2" /> <!-- Section title -->
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col lg="4" md="6" sm="6" cols="12" class="mb-3">
          <Skeleton width="60%" height="0.9rem" class="mb-2" /> <!-- Field label -->
          <Skeleton height="2.5rem" />
        </b-col>
        <b-col lg="4" md="6" sm="6" cols="12" class="mb-3">
          <Skeleton width="40%" height="0.9rem" class="mb-2" /> <!-- Field label -->
          <Skeleton height="2.5rem" />
        </b-col>
        <b-col lg="4" md="6" sm="6" cols="12" class="mb-3">
          <Skeleton width="50%" height="0.9rem" class="mb-2" /> <!-- Field label -->
          <Skeleton height="2.5rem" />
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="6" md="6" sm="12" cols="12" class="mb-3">
          <Skeleton width="35%" height="0.9rem" class="mb-2" /> <!-- Field label -->
          <Skeleton height="2.5rem" />
        </b-col>
        <b-col lg="6" md="6" sm="12" cols="12" class="mb-3">
          <Skeleton width="45%" height="0.9rem" class="mb-2" /> <!-- Field label -->
          <Skeleton height="2.5rem" />
        </b-col>
      </b-row>
    </div>

    <!-- Form Fields Section 2 -->
    <div class="form-section mb-4">
      <b-row>
        <b-col cols="12">
          <Skeleton width="20%" height="1.2rem" class="mb-3" /> <!-- Section title -->
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="3" md="4" sm="6" cols="12" class="mb-3" v-for="i in 4" :key="`field-${i}`">
          <Skeleton width="55%" height="0.9rem" class="mb-2" /> <!-- Field label -->
          <Skeleton height="2.5rem" />
        </b-col>
      </b-row>
    </div>

    <!-- Textarea Section -->
    <div class="form-section mb-4">
      <b-row>
        <b-col cols="12" class="mb-3">
          <Skeleton width="30%" height="0.9rem" class="mb-2" /> <!-- Field label -->
          <Skeleton height="6rem" />
        </b-col>
      </b-row>
    </div>

    <!-- Checkbox/Radio Section -->
    <div class="form-section mb-4">
      <b-row>
        <b-col cols="12">
          <Skeleton width="15%" height="1.2rem" class="mb-3" /> <!-- Section title -->
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="3" md="4" sm="6" cols="12" class="mb-2" v-for="i in 3" :key="`option-${i}`">
          <div class="d-flex align-items-center">
            <Skeleton width="1rem" height="1rem" class="me-2" style="border-radius: 3px;" />
            <Skeleton width="60%" height="0.9rem" />
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Form Buttons -->
    <div class="form-section">
      <b-row class="d-flex flex-row-reverse">
        <b-col lg="2" md="3" sm="4" cols="6" class="mb-2">
          <Skeleton height="2.5rem" />
        </b-col>
        <b-col lg="2" md="3" sm="4" cols="6" class="mb-2">
          <Skeleton height="2.5rem" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FormSkeletonLoader',
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
  }
})
</script>

<style scoped>
.form-skeleton-loader {
  padding: 0.5rem;
}

.form-section {
  position: relative;
}

/* Add a subtle animation to make the skeleton more lively */
:deep(.p-skeleton) {
  animation: skeleton-animation 1.5s infinite ease-in-out;
  background: linear-gradient(90deg, rgba(227, 227, 227, 0.4) 25%, rgba(227, 227, 227, 0.7) 37%, rgba(227, 227, 227, 0.4) 63%);
  background-size: 400% 100%;
}

@keyframes skeleton-animation {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}
</style>